module.exports = __webpack_public_path__ + "media/images/S-45126038cd28f16bd37ee3b157e74dae.gif";